import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const commonConfigSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'commonConfig'

export const config = { site: commonConfigSiteConfig, reactNativeSite: commonConfigSiteConfig, name }
